import React from 'react';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "react-bootstrap/Alert";
import SaluteCard from "./Common/HomeWidgets/Widgets/Salute/SaluteCard";
import WidgetRow from "./Common/HomeWidgets/WidgetRow/WidgetRow";
import {Col, Container, Row} from "react-bootstrap";
import ActiveCases from "./HomeTable/ActiveCases";

const Unauthorized = ({userProfile}) => {
    return (
        <Container fluid>
            <SaluteCard props={{firstName: userProfile?.firstName ?? ''}} />
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h1>Unauthorized Access</h1>
                <p>You do not have permission to access this page.</p>
                <p>Contact us if this is a mistake</p>
            </div>
        </Container>
    );
};

export default Unauthorized;
